import styled from "styled-components"

import { MEDIA_QUERIES } from "@constants"

export const IntegrationPageContentDIV = styled.div`
  max-width: max(727px, calc((var(--container-width) / 12 * 7) - (var(--spacing--M) * 5 / 12)));
  margin: 0 auto;

  ul:last-of-type {
    list-style: none;
    margin: 0 0 30px;
    padding: 0;
    font-size: var(--font-size--M);

    li {
      position: relative;
      padding: 5px 0 5px 28px;
      margin-bottom: 10px;

      p:last-of-type {
        margin: 0;
      }

      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 13px;
        left: 0;
        width: 16px;
        height: 16px;
        background: center center / 16px 16px url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiIGZpbGw9IiM1NkMyODgiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjU0MTkxIDEzLjc1MDJDOC4yOTMwMiAxMy43NTAyIDguMDQ0MTMgMTMuNjU0IDcuODU0NTUgMTMuNDYyNUw1LjkxMDEgMTEuNDk4MkM1LjUyOTk3IDExLjExNDIgNS41Mjk5NyAxMC40OTM1IDUuOTEwMSAxMC4xMDk0QzYuMjkwMjQgOS43MjU0MiA2LjkwNDY5IDkuNzI1NDIgNy4yODQ4MyAxMC4xMDk0TDguNTQxOTEgMTEuMzc5NEwxMi43MTU3IDcuMTYzMDFDMTMuMDk1OCA2Ljc3OSAxMy43MTAyIDYuNzc5IDE0LjA5MDQgNy4xNjMwMUMxNC40NzA1IDcuNTQ3MDMgMTQuNDcwNSA4LjE2Nzc1IDE0LjA5MDQgOC41NTE3Nkw5LjIyOTI3IDEzLjQ2MjVDOS4wMzk2OSAxMy42NTQgOC43OTA4IDEzLjc1MDIgOC41NDE5MSAxMy43NTAyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==) no-repeat;
      }
    }

    ${MEDIA_QUERIES.M} {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 0 var(--spacing--M);
    }
  }
`
